import script from "./BaseNewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseNewsCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseNewsCard.vue?vue&type=style&index=0&id=fa30a596&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa30a596"]])

export default __exports__